/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * wellcheck-customer
 * OpenAPI spec version: 0.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ContactEditSessionInfo,
  ContactEditUpdateContactResponse,
  ErrorModel,
  GetRespondentLinkReissueParams,
  GetRespondentQuestionnaireParams,
  OfficeInputSessionInfo,
  QuestionnaireResponse,
  RespondentsLinkReissueAccepted,
  RespondentsLinkReissueRequest,
  RespondentsLinkReissueStatus,
  SessionInfo,
  StatusResponse,
  SubmitAnswersInput,
  SubmitAnswersResponse,
  SubmitInput,
  SubmitResponse,
  UpdateContactInput
} from './model';

import { customFetch } from '../../lib/mutator';
import type { ErrorType , BodyType } from '../../lib/mutator';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;


export type getContactEditSessionResponse200 = {
  data: ContactEditSessionInfo
  status: 200
}

export type getContactEditSessionResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type getContactEditSessionResponseSuccess = (getContactEditSessionResponse200) & {
  headers: Headers;
};
export type getContactEditSessionResponseError = (getContactEditSessionResponseDefault) & {
  headers: Headers;
};

export type getContactEditSessionResponse = (getContactEditSessionResponseSuccess | getContactEditSessionResponseError)

export const getGetContactEditSessionUrl = () => {




  return `/api/contact-edit-session`
}

/**
 * __Host-wc_contact_edit_session Cookie を検証し、修正フォームの初期値となる現在の氏名・メールアドレスを返す。Cookie が無い/不正/期限切れ、または respondent/campaign が見つからない場合は 401。修正受付期限 (実施開始日の前日いっぱい) を過ぎている場合は 409。
 * @summary 連絡先修正セッションの確認
 */
export const getContactEditSession = async ( options?: RequestInit): Promise<getContactEditSessionResponse> => {

  return customFetch<getContactEditSessionResponse>(getGetContactEditSessionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetContactEditSessionQueryKey = () => {
    return [
    `/api/contact-edit-session`
    ] as const;
    }


export const getGetContactEditSessionQueryOptions = <TData = Awaited<ReturnType<typeof getContactEditSession>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactEditSession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContactEditSessionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactEditSession>>> = ({ signal }) => getContactEditSession({ signal, ...requestOptions });





   return  { queryKey, queryFn,   staleTime: 30000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContactEditSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetContactEditSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getContactEditSession>>>
export type GetContactEditSessionQueryError = ErrorType<ErrorModel>


export function useGetContactEditSession<TData = Awaited<ReturnType<typeof getContactEditSession>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactEditSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactEditSession>>,
          TError,
          Awaited<ReturnType<typeof getContactEditSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContactEditSession<TData = Awaited<ReturnType<typeof getContactEditSession>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactEditSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactEditSession>>,
          TError,
          Awaited<ReturnType<typeof getContactEditSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContactEditSession<TData = Awaited<ReturnType<typeof getContactEditSession>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactEditSession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 連絡先修正セッションの確認
 */

export function useGetContactEditSession<TData = Awaited<ReturnType<typeof getContactEditSession>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactEditSession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetContactEditSessionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateContactBySelfResponse200 = {
  data: ContactEditUpdateContactResponse
  status: 200
}

export type updateContactBySelfResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type updateContactBySelfResponseSuccess = (updateContactBySelfResponse200) & {
  headers: Headers;
};
export type updateContactBySelfResponseError = (updateContactBySelfResponseDefault) & {
  headers: Headers;
};

export type updateContactBySelfResponse = (updateContactBySelfResponseSuccess | updateContactBySelfResponseError)

export const getUpdateContactBySelfUrl = () => {




  return `/api/contact-edit-session/contact`
}

/**
 * __Host-wc_contact_edit_session Cookie を検証し、本人が自分の氏名・メールアドレスを更新する (ADR-0041)。修正受付期限 (実施開始日の前日いっぱい) を過ぎている場合は 409。案内送信済み・未回答の状態でメールアドレスを変更した場合、変更後のアドレスへ案内メールを再送する。
 * @summary 本人による氏名・メールアドレスの修正
 */
export const updateContactBySelf = async (updateContactInput: NonReadonly<UpdateContactInput>, options?: RequestInit): Promise<updateContactBySelfResponse> => {

  return customFetch<updateContactBySelfResponse>(getUpdateContactBySelfUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateContactInput)
  }
);}





export const getUpdateContactBySelfQueryKey = (updateContactInput?: BodyType<NonReadonly<UpdateContactInput>>,) => {
    return [
    'PATCH', `/api/contact-edit-session/contact`, updateContactInput
    ] as const;
    }


export const getUpdateContactBySelfQueryOptions = <TData = Awaited<ReturnType<typeof updateContactBySelf>>, TError = ErrorType<ErrorModel>>(updateContactInput: BodyType<NonReadonly<UpdateContactInput>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateContactBySelf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUpdateContactBySelfQueryKey(updateContactInput);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof updateContactBySelf>>> = ({ signal }) => updateContactBySelf(updateContactInput, { signal, ...requestOptions });





   return  { queryKey, queryFn,   staleTime: 30000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof updateContactBySelf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UpdateContactBySelfQueryResult = NonNullable<Awaited<ReturnType<typeof updateContactBySelf>>>
export type UpdateContactBySelfQueryError = ErrorType<ErrorModel>


export function useUpdateContactBySelf<TData = Awaited<ReturnType<typeof updateContactBySelf>>, TError = ErrorType<ErrorModel>>(
 updateContactInput: BodyType<NonReadonly<UpdateContactInput>>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateContactBySelf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateContactBySelf>>,
          TError,
          Awaited<ReturnType<typeof updateContactBySelf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUpdateContactBySelf<TData = Awaited<ReturnType<typeof updateContactBySelf>>, TError = ErrorType<ErrorModel>>(
 updateContactInput: BodyType<NonReadonly<UpdateContactInput>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateContactBySelf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateContactBySelf>>,
          TError,
          Awaited<ReturnType<typeof updateContactBySelf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUpdateContactBySelf<TData = Awaited<ReturnType<typeof updateContactBySelf>>, TError = ErrorType<ErrorModel>>(
 updateContactInput: BodyType<NonReadonly<UpdateContactInput>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateContactBySelf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 本人による氏名・メールアドレスの修正
 */

export function useUpdateContactBySelf<TData = Awaited<ReturnType<typeof updateContactBySelf>>, TError = ErrorType<ErrorModel>>(
 updateContactInput: BodyType<NonReadonly<UpdateContactInput>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateContactBySelf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUpdateContactBySelfQueryOptions(updateContactInput,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type submitRespondentAnswersResponse200 = {
  data: SubmitAnswersResponse
  status: 200
}

export type submitRespondentAnswersResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type submitRespondentAnswersResponseSuccess = (submitRespondentAnswersResponse200) & {
  headers: Headers;
};
export type submitRespondentAnswersResponseError = (submitRespondentAnswersResponseDefault) & {
  headers: Headers;
};

export type submitRespondentAnswersResponse = (submitRespondentAnswersResponseSuccess | submitRespondentAnswersResponseError)

export const getSubmitRespondentAnswersUrl = () => {




  return `/api/respondent-answers`
}

/**
 * __Host-wc_respondent_session Cookie を検証し、全項目の回答を単一トランザクションで保存する。二重提出は 409。
 * @summary 回答提出
 */
export const submitRespondentAnswers = async (submitAnswersInput: NonReadonly<SubmitAnswersInput>, options?: RequestInit): Promise<submitRespondentAnswersResponse> => {

  return customFetch<submitRespondentAnswersResponse>(getSubmitRespondentAnswersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submitAnswersInput)
  }
);}





export const getSubmitRespondentAnswersQueryKey = (submitAnswersInput?: BodyType<NonReadonly<SubmitAnswersInput>>,) => {
    return [
    'POST', `/api/respondent-answers`, submitAnswersInput
    ] as const;
    }


export const getSubmitRespondentAnswersQueryOptions = <TData = Awaited<ReturnType<typeof submitRespondentAnswers>>, TError = ErrorType<ErrorModel>>(submitAnswersInput: BodyType<NonReadonly<SubmitAnswersInput>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitRespondentAnswers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubmitRespondentAnswersQueryKey(submitAnswersInput);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof submitRespondentAnswers>>> = ({ signal }) => submitRespondentAnswers(submitAnswersInput, { signal, ...requestOptions });





   return  { queryKey, queryFn,   staleTime: 30000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof submitRespondentAnswers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SubmitRespondentAnswersQueryResult = NonNullable<Awaited<ReturnType<typeof submitRespondentAnswers>>>
export type SubmitRespondentAnswersQueryError = ErrorType<ErrorModel>


export function useSubmitRespondentAnswers<TData = Awaited<ReturnType<typeof submitRespondentAnswers>>, TError = ErrorType<ErrorModel>>(
 submitAnswersInput: BodyType<NonReadonly<SubmitAnswersInput>>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitRespondentAnswers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof submitRespondentAnswers>>,
          TError,
          Awaited<ReturnType<typeof submitRespondentAnswers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSubmitRespondentAnswers<TData = Awaited<ReturnType<typeof submitRespondentAnswers>>, TError = ErrorType<ErrorModel>>(
 submitAnswersInput: BodyType<NonReadonly<SubmitAnswersInput>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitRespondentAnswers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof submitRespondentAnswers>>,
          TError,
          Awaited<ReturnType<typeof submitRespondentAnswers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSubmitRespondentAnswers<TData = Awaited<ReturnType<typeof submitRespondentAnswers>>, TError = ErrorType<ErrorModel>>(
 submitAnswersInput: BodyType<NonReadonly<SubmitAnswersInput>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitRespondentAnswers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 回答提出
 */

export function useSubmitRespondentAnswers<TData = Awaited<ReturnType<typeof submitRespondentAnswers>>, TError = ErrorType<ErrorModel>>(
 submitAnswersInput: BodyType<NonReadonly<SubmitAnswersInput>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitRespondentAnswers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSubmitRespondentAnswersQueryOptions(submitAnswersInput,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getRespondentLinkReissueResponse200 = {
  data: RespondentsLinkReissueStatus
  status: 200
}

export type getRespondentLinkReissueResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type getRespondentLinkReissueResponseSuccess = (getRespondentLinkReissueResponse200) & {
  headers: Headers;
};
export type getRespondentLinkReissueResponseError = (getRespondentLinkReissueResponseDefault) & {
  headers: Headers;
};

export type getRespondentLinkReissueResponse = (getRespondentLinkReissueResponseSuccess | getRespondentLinkReissueResponseError)

export const getGetRespondentLinkReissueUrl = (params: GetRespondentLinkReissueParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/respondent-link-reissue?${stringifiedParams}` : `/api/respondent-link-reissue`
}

/**
 * campaignRecordId/respondentRecordId の組が本人による回答リンク再発行の対象かを 4 状態 (eligible/throttled/closed/ineligible) で返す。eligible/throttled のときのみマスク済みの送信先メールアドレスを返す (ADR-0061)。
 * @summary 回答リンク再発行の対象確認
 */
export const getRespondentLinkReissue = async (params: GetRespondentLinkReissueParams, options?: RequestInit): Promise<getRespondentLinkReissueResponse> => {

  return customFetch<getRespondentLinkReissueResponse>(getGetRespondentLinkReissueUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRespondentLinkReissueQueryKey = (params?: GetRespondentLinkReissueParams,) => {
    return [
    `/api/respondent-link-reissue`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRespondentLinkReissueQueryOptions = <TData = Awaited<ReturnType<typeof getRespondentLinkReissue>>, TError = ErrorType<ErrorModel>>(params: GetRespondentLinkReissueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentLinkReissue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRespondentLinkReissueQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRespondentLinkReissue>>> = ({ signal }) => getRespondentLinkReissue(params, { signal, ...requestOptions });





   return  { queryKey, queryFn,   staleTime: 30000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRespondentLinkReissue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRespondentLinkReissueQueryResult = NonNullable<Awaited<ReturnType<typeof getRespondentLinkReissue>>>
export type GetRespondentLinkReissueQueryError = ErrorType<ErrorModel>


export function useGetRespondentLinkReissue<TData = Awaited<ReturnType<typeof getRespondentLinkReissue>>, TError = ErrorType<ErrorModel>>(
 params: GetRespondentLinkReissueParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentLinkReissue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRespondentLinkReissue>>,
          TError,
          Awaited<ReturnType<typeof getRespondentLinkReissue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRespondentLinkReissue<TData = Awaited<ReturnType<typeof getRespondentLinkReissue>>, TError = ErrorType<ErrorModel>>(
 params: GetRespondentLinkReissueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentLinkReissue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRespondentLinkReissue>>,
          TError,
          Awaited<ReturnType<typeof getRespondentLinkReissue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRespondentLinkReissue<TData = Awaited<ReturnType<typeof getRespondentLinkReissue>>, TError = ErrorType<ErrorModel>>(
 params: GetRespondentLinkReissueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentLinkReissue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 回答リンク再発行の対象確認
 */

export function useGetRespondentLinkReissue<TData = Awaited<ReturnType<typeof getRespondentLinkReissue>>, TError = ErrorType<ErrorModel>>(
 params: GetRespondentLinkReissueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentLinkReissue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRespondentLinkReissueQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type reissueRespondentLinkResponse202 = {
  data: RespondentsLinkReissueAccepted
  status: 202
}

export type reissueRespondentLinkResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 202>
}

export type reissueRespondentLinkResponseSuccess = (reissueRespondentLinkResponse202) & {
  headers: Headers;
};
export type reissueRespondentLinkResponseError = (reissueRespondentLinkResponseDefault) & {
  headers: Headers;
};

export type reissueRespondentLinkResponse = (reissueRespondentLinkResponseSuccess | reissueRespondentLinkResponseError)

export const getReissueRespondentLinkUrl = () => {




  return `/api/respondent-link-reissue`
}

/**
 * 対象確認で eligible=true だった campaignRecordId/respondentRecordId 宛てに新しい回答リンクを再発行して送信する (ADR-0061)。対象外・cooldown 中でも同じ 202 を返す (却下理由を外部に開示しない、ユーザー決定)。
 * @summary 回答リンクの再発行
 */
export const reissueRespondentLink = async (respondentsLinkReissueRequest: NonReadonly<RespondentsLinkReissueRequest>, options?: RequestInit): Promise<reissueRespondentLinkResponse> => {

  return customFetch<reissueRespondentLinkResponse>(getReissueRespondentLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(respondentsLinkReissueRequest)
  }
);}





export const getReissueRespondentLinkQueryKey = (respondentsLinkReissueRequest?: BodyType<NonReadonly<RespondentsLinkReissueRequest>>,) => {
    return [
    'POST', `/api/respondent-link-reissue`, respondentsLinkReissueRequest
    ] as const;
    }


export const getReissueRespondentLinkQueryOptions = <TData = Awaited<ReturnType<typeof reissueRespondentLink>>, TError = ErrorType<ErrorModel>>(respondentsLinkReissueRequest: BodyType<NonReadonly<RespondentsLinkReissueRequest>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reissueRespondentLink>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReissueRespondentLinkQueryKey(respondentsLinkReissueRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reissueRespondentLink>>> = ({ signal }) => reissueRespondentLink(respondentsLinkReissueRequest, { signal, ...requestOptions });





   return  { queryKey, queryFn,   staleTime: 30000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reissueRespondentLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ReissueRespondentLinkQueryResult = NonNullable<Awaited<ReturnType<typeof reissueRespondentLink>>>
export type ReissueRespondentLinkQueryError = ErrorType<ErrorModel>


export function useReissueRespondentLink<TData = Awaited<ReturnType<typeof reissueRespondentLink>>, TError = ErrorType<ErrorModel>>(
 respondentsLinkReissueRequest: BodyType<NonReadonly<RespondentsLinkReissueRequest>>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reissueRespondentLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reissueRespondentLink>>,
          TError,
          Awaited<ReturnType<typeof reissueRespondentLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useReissueRespondentLink<TData = Awaited<ReturnType<typeof reissueRespondentLink>>, TError = ErrorType<ErrorModel>>(
 respondentsLinkReissueRequest: BodyType<NonReadonly<RespondentsLinkReissueRequest>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reissueRespondentLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reissueRespondentLink>>,
          TError,
          Awaited<ReturnType<typeof reissueRespondentLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useReissueRespondentLink<TData = Awaited<ReturnType<typeof reissueRespondentLink>>, TError = ErrorType<ErrorModel>>(
 respondentsLinkReissueRequest: BodyType<NonReadonly<RespondentsLinkReissueRequest>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reissueRespondentLink>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 回答リンクの再発行
 */

export function useReissueRespondentLink<TData = Awaited<ReturnType<typeof reissueRespondentLink>>, TError = ErrorType<ErrorModel>>(
 respondentsLinkReissueRequest: BodyType<NonReadonly<RespondentsLinkReissueRequest>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reissueRespondentLink>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getReissueRespondentLinkQueryOptions(respondentsLinkReissueRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getRespondentQuestionnaireResponse200 = {
  data: QuestionnaireResponse
  status: 200
}

export type getRespondentQuestionnaireResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type getRespondentQuestionnaireResponseSuccess = (getRespondentQuestionnaireResponse200) & {
  headers: Headers;
};
export type getRespondentQuestionnaireResponseError = (getRespondentQuestionnaireResponseDefault) & {
  headers: Headers;
};

export type getRespondentQuestionnaireResponse = (getRespondentQuestionnaireResponseSuccess | getRespondentQuestionnaireResponseError)

export const getGetRespondentQuestionnaireUrl = (params?: GetRespondentQuestionnaireParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/respondent-questionnaire?${stringifiedParams}` : `/api/respondent-questionnaire`
}

/**
 * __Host-wc_respondent_session Cookie を検証し、campaign の質問票 (57 または 80 項目) と回答進捗を返す。lang クエリで表示言語を指定できる (未指定・不正値は ja、ADR-0033)。
 * @summary 回答者向け設問取得
 */
export const getRespondentQuestionnaire = async (params?: GetRespondentQuestionnaireParams, options?: RequestInit): Promise<getRespondentQuestionnaireResponse> => {

  return customFetch<getRespondentQuestionnaireResponse>(getGetRespondentQuestionnaireUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRespondentQuestionnaireQueryKey = (params?: GetRespondentQuestionnaireParams,) => {
    return [
    `/api/respondent-questionnaire`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRespondentQuestionnaireQueryOptions = <TData = Awaited<ReturnType<typeof getRespondentQuestionnaire>>, TError = ErrorType<ErrorModel>>(params?: GetRespondentQuestionnaireParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRespondentQuestionnaireQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRespondentQuestionnaire>>> = ({ signal }) => getRespondentQuestionnaire(params, { signal, ...requestOptions });





   return  { queryKey, queryFn,   staleTime: 30000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRespondentQuestionnaire>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRespondentQuestionnaireQueryResult = NonNullable<Awaited<ReturnType<typeof getRespondentQuestionnaire>>>
export type GetRespondentQuestionnaireQueryError = ErrorType<ErrorModel>


export function useGetRespondentQuestionnaire<TData = Awaited<ReturnType<typeof getRespondentQuestionnaire>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetRespondentQuestionnaireParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentQuestionnaire>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRespondentQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof getRespondentQuestionnaire>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRespondentQuestionnaire<TData = Awaited<ReturnType<typeof getRespondentQuestionnaire>>, TError = ErrorType<ErrorModel>>(
 params?: GetRespondentQuestionnaireParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentQuestionnaire>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRespondentQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof getRespondentQuestionnaire>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRespondentQuestionnaire<TData = Awaited<ReturnType<typeof getRespondentQuestionnaire>>, TError = ErrorType<ErrorModel>>(
 params?: GetRespondentQuestionnaireParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 回答者向け設問取得
 */

export function useGetRespondentQuestionnaire<TData = Awaited<ReturnType<typeof getRespondentQuestionnaire>>, TError = ErrorType<ErrorModel>>(
 params?: GetRespondentQuestionnaireParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRespondentQuestionnaireQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getRespondentSessionResponse200 = {
  data: SessionInfo
  status: 200
}

export type getRespondentSessionResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type getRespondentSessionResponseSuccess = (getRespondentSessionResponse200) & {
  headers: Headers;
};
export type getRespondentSessionResponseError = (getRespondentSessionResponseDefault) & {
  headers: Headers;
};

export type getRespondentSessionResponse = (getRespondentSessionResponseSuccess | getRespondentSessionResponseError)

export const getGetRespondentSessionUrl = () => {




  return `/api/respondent-session`
}

/**
 * __Host-wc_respondent_session Cookie を検証し、本人確認 UI 向けの概要を返す。Cookie が無い/不正/期限切れ、または respondent が見つからない場合は 401。
 * @summary 回答者セッションの確認
 */
export const getRespondentSession = async ( options?: RequestInit): Promise<getRespondentSessionResponse> => {

  return customFetch<getRespondentSessionResponse>(getGetRespondentSessionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRespondentSessionQueryKey = () => {
    return [
    `/api/respondent-session`
    ] as const;
    }


export const getGetRespondentSessionQueryOptions = <TData = Awaited<ReturnType<typeof getRespondentSession>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentSession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRespondentSessionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRespondentSession>>> = ({ signal }) => getRespondentSession({ signal, ...requestOptions });





   return  { queryKey, queryFn,   staleTime: 30000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRespondentSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRespondentSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getRespondentSession>>>
export type GetRespondentSessionQueryError = ErrorType<ErrorModel>


export function useGetRespondentSession<TData = Awaited<ReturnType<typeof getRespondentSession>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRespondentSession>>,
          TError,
          Awaited<ReturnType<typeof getRespondentSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRespondentSession<TData = Awaited<ReturnType<typeof getRespondentSession>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRespondentSession>>,
          TError,
          Awaited<ReturnType<typeof getRespondentSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRespondentSession<TData = Awaited<ReturnType<typeof getRespondentSession>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentSession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 回答者セッションの確認
 */

export function useGetRespondentSession<TData = Awaited<ReturnType<typeof getRespondentSession>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRespondentSession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRespondentSessionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getUploadSessionResponse200 = {
  data: OfficeInputSessionInfo
  status: 200
}

export type getUploadSessionResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type getUploadSessionResponseSuccess = (getUploadSessionResponse200) & {
  headers: Headers;
};
export type getUploadSessionResponseError = (getUploadSessionResponseDefault) & {
  headers: Headers;
};

export type getUploadSessionResponse = (getUploadSessionResponseSuccess | getUploadSessionResponseError)

export const getGetUploadSessionUrl = () => {




  return `/api/upload-session`
}

/**
 * __Host-wc_upload_session Cookie を検証し、本人確認 UI 向けの概要を返す。Cookie が無い/不正/期限切れ、または campaign が見つからない場合は 401。
 * @summary アップロードセッションの確認
 */
export const getUploadSession = async ( options?: RequestInit): Promise<getUploadSessionResponse> => {

  return customFetch<getUploadSessionResponse>(getGetUploadSessionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUploadSessionQueryKey = () => {
    return [
    `/api/upload-session`
    ] as const;
    }


export const getGetUploadSessionQueryOptions = <TData = Awaited<ReturnType<typeof getUploadSession>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadSession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUploadSessionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUploadSession>>> = ({ signal }) => getUploadSession({ signal, ...requestOptions });





   return  { queryKey, queryFn,   staleTime: 30000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUploadSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUploadSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getUploadSession>>>
export type GetUploadSessionQueryError = ErrorType<ErrorModel>


export function useGetUploadSession<TData = Awaited<ReturnType<typeof getUploadSession>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUploadSession>>,
          TError,
          Awaited<ReturnType<typeof getUploadSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUploadSession<TData = Awaited<ReturnType<typeof getUploadSession>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUploadSession>>,
          TError,
          Awaited<ReturnType<typeof getUploadSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUploadSession<TData = Awaited<ReturnType<typeof getUploadSession>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadSession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary アップロードセッションの確認
 */

export function useGetUploadSession<TData = Awaited<ReturnType<typeof getUploadSession>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadSession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUploadSessionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type submitUploadResponse200 = {
  data: SubmitResponse
  status: 200
}

export type submitUploadResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type submitUploadResponseSuccess = (submitUploadResponse200) & {
  headers: Headers;
};
export type submitUploadResponseError = (submitUploadResponseDefault) & {
  headers: Headers;
};

export type submitUploadResponse = (submitUploadResponseSuccess | submitUploadResponseError)

export const getSubmitUploadUrl = () => {




  return `/api/upload-session/submit`
}

/**
 * __Host-wc_upload_session Cookie を検証し、名簿 CSV と実施期間を確定する。バリデーション失敗は行単位エラーの配列を含む 400、二重送信 / phase 不一致は 409。
 * @summary 名簿アップロード確定
 */
export const submitUpload = async (submitInput: NonReadonly<SubmitInput>, options?: RequestInit): Promise<submitUploadResponse> => {

  return customFetch<submitUploadResponse>(getSubmitUploadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submitInput)
  }
);}





export const getSubmitUploadQueryKey = (submitInput?: BodyType<NonReadonly<SubmitInput>>,) => {
    return [
    'POST', `/api/upload-session/submit`, submitInput
    ] as const;
    }


export const getSubmitUploadQueryOptions = <TData = Awaited<ReturnType<typeof submitUpload>>, TError = ErrorType<ErrorModel>>(submitInput: BodyType<NonReadonly<SubmitInput>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitUpload>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubmitUploadQueryKey(submitInput);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof submitUpload>>> = ({ signal }) => submitUpload(submitInput, { signal, ...requestOptions });





   return  { queryKey, queryFn,   staleTime: 30000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof submitUpload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SubmitUploadQueryResult = NonNullable<Awaited<ReturnType<typeof submitUpload>>>
export type SubmitUploadQueryError = ErrorType<ErrorModel>


export function useSubmitUpload<TData = Awaited<ReturnType<typeof submitUpload>>, TError = ErrorType<ErrorModel>>(
 submitInput: BodyType<NonReadonly<SubmitInput>>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitUpload>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof submitUpload>>,
          TError,
          Awaited<ReturnType<typeof submitUpload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSubmitUpload<TData = Awaited<ReturnType<typeof submitUpload>>, TError = ErrorType<ErrorModel>>(
 submitInput: BodyType<NonReadonly<SubmitInput>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitUpload>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof submitUpload>>,
          TError,
          Awaited<ReturnType<typeof submitUpload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSubmitUpload<TData = Awaited<ReturnType<typeof submitUpload>>, TError = ErrorType<ErrorModel>>(
 submitInput: BodyType<NonReadonly<SubmitInput>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitUpload>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 名簿アップロード確定
 */

export function useSubmitUpload<TData = Awaited<ReturnType<typeof submitUpload>>, TError = ErrorType<ErrorModel>>(
 submitInput: BodyType<NonReadonly<SubmitInput>>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitUpload>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSubmitUploadQueryOptions(submitInput,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type healthzLivenessResponse200 = {
  data: StatusResponse
  status: 200
}

export type healthzLivenessResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type healthzLivenessResponseSuccess = (healthzLivenessResponse200) & {
  headers: Headers;
};
export type healthzLivenessResponseError = (healthzLivenessResponseDefault) & {
  headers: Headers;
};

export type healthzLivenessResponse = (healthzLivenessResponseSuccess | healthzLivenessResponseError)

export const getHealthzLivenessUrl = () => {




  return `/healthz/liveness`
}

/**
 * プロセスが生きているかを返す Cloud Run liveness 用プローブ。
 * @summary Liveness probe
 */
export const healthzLiveness = async ( options?: RequestInit): Promise<healthzLivenessResponse> => {

  return customFetch<healthzLivenessResponse>(getHealthzLivenessUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthzLivenessQueryKey = () => {
    return [
    `/healthz/liveness`
    ] as const;
    }


export const getHealthzLivenessQueryOptions = <TData = Awaited<ReturnType<typeof healthzLiveness>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzLiveness>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthzLivenessQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthzLiveness>>> = ({ signal }) => healthzLiveness({ signal, ...requestOptions });





   return  { queryKey, queryFn,   staleTime: 30000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthzLiveness>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HealthzLivenessQueryResult = NonNullable<Awaited<ReturnType<typeof healthzLiveness>>>
export type HealthzLivenessQueryError = ErrorType<ErrorModel>


export function useHealthzLiveness<TData = Awaited<ReturnType<typeof healthzLiveness>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzLiveness>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthzLiveness>>,
          TError,
          Awaited<ReturnType<typeof healthzLiveness>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHealthzLiveness<TData = Awaited<ReturnType<typeof healthzLiveness>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzLiveness>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthzLiveness>>,
          TError,
          Awaited<ReturnType<typeof healthzLiveness>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHealthzLiveness<TData = Awaited<ReturnType<typeof healthzLiveness>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzLiveness>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Liveness probe
 */

export function useHealthzLiveness<TData = Awaited<ReturnType<typeof healthzLiveness>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzLiveness>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHealthzLivenessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type healthzReadinessResponse200 = {
  data: StatusResponse
  status: 200
}

export type healthzReadinessResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type healthzReadinessResponseSuccess = (healthzReadinessResponse200) & {
  headers: Headers;
};
export type healthzReadinessResponseError = (healthzReadinessResponseDefault) & {
  headers: Headers;
};

export type healthzReadinessResponse = (healthzReadinessResponseSuccess | healthzReadinessResponseError)

export const getHealthzReadinessUrl = () => {




  return `/healthz/readiness`
}

/**
 * リクエスト受付可能かを返す Cloud Run readiness 用プローブ。
 * @summary Readiness probe
 */
export const healthzReadiness = async ( options?: RequestInit): Promise<healthzReadinessResponse> => {

  return customFetch<healthzReadinessResponse>(getHealthzReadinessUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthzReadinessQueryKey = () => {
    return [
    `/healthz/readiness`
    ] as const;
    }


export const getHealthzReadinessQueryOptions = <TData = Awaited<ReturnType<typeof healthzReadiness>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzReadiness>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthzReadinessQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthzReadiness>>> = ({ signal }) => healthzReadiness({ signal, ...requestOptions });





   return  { queryKey, queryFn,   staleTime: 30000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthzReadiness>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HealthzReadinessQueryResult = NonNullable<Awaited<ReturnType<typeof healthzReadiness>>>
export type HealthzReadinessQueryError = ErrorType<ErrorModel>


export function useHealthzReadiness<TData = Awaited<ReturnType<typeof healthzReadiness>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzReadiness>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthzReadiness>>,
          TError,
          Awaited<ReturnType<typeof healthzReadiness>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHealthzReadiness<TData = Awaited<ReturnType<typeof healthzReadiness>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzReadiness>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthzReadiness>>,
          TError,
          Awaited<ReturnType<typeof healthzReadiness>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHealthzReadiness<TData = Awaited<ReturnType<typeof healthzReadiness>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzReadiness>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Readiness probe
 */

export function useHealthzReadiness<TData = Awaited<ReturnType<typeof healthzReadiness>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzReadiness>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHealthzReadinessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  return { ...query, queryKey: queryOptions.queryKey };
}







